import { render, staticRenderFns } from "./CallIvrMenu.vue?vue&type=template&id=c4db1042&"
import script from "./CallIvrMenu.vue?vue&type=script&lang=ts&"
export * from "./CallIvrMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports